import Detail from './Detail';
import List from './List';
import NewEdit from './NewEdit';

export {
    List,
    NewEdit,
    Detail,
};
